import { ChevronDown } from 'lucide-react';
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
} from '@/components/ui/dropdown-menu';
import { Button } from '@/components/ui/button';
import {MouseEventHandler} from "react";

export interface IDropdownOption {
  label: string;
  icon?: React.ReactNode;
  onClick: MouseEventHandler<HTMLDivElement>
}

export interface IDropdownTableHeader {
  type: 'dropdown';
  label: string;
  options: IDropdownOption[];
}
type Props = Omit<IDropdownTableHeader, 'type'>
export const DropdownTableHeader: React.FC<Props> = ({
  label,
  options,
}) => {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="outline"
          size="sm"
          className="h-8 gap-1"
          aria-label={label}
        >
          <span>{label}</span>
          <ChevronDown className="h-3.5 w-3.5" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-48">
        <DropdownMenuLabel>{label}</DropdownMenuLabel>
        <DropdownMenuSeparator />
        {options.map((option, index) => (
          <DropdownMenuItem
            key={index}
            onClick={option.onClick}
            className="cursor-pointer"
          >
            {option.icon}
            <span className="ml-2">{option.label}</span>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};